<div class="map">
  <div id="google-map"></div>
</div>
